export enum RetailChannel {
  MULTIFUNCTION = 'multifunction',
}
